import API from "@/api"
import { MatryxCommit, MatryxPlatform, MatryxToken } from "@/web3/contracts"

const state = {
  artifacts: {},
  Commit: null,
  Platform: null,
  Token: null
}

export const mutations = {
  REGISTER_ARTIFACTS(state, payload) {
    state.artifacts = payload
  },

  CREATE_CONTRACTS(state) {
    const { platform, commit, token } = state.artifacts
    state.Platform = Promise.resolve(new MatryxPlatform(platform.address, platform.abi))
    state.Commit = Promise.resolve(new MatryxCommit(commit.address, commit.abi))
    state.Token = Promise.resolve(new MatryxToken(token.address, token.abi))
  }
}

export const actions = {
  async fetchArtifacts({ commit }) {
    const { success, data } = await API.getArtifacts()
    if (!success) {
      throw new Error("Unknown error fetching artifacts.")
    }
    commit("REGISTER_ARTIFACTS", data)
  },

  createContracts({ commit }) {
    commit("CREATE_CONTRACTS")
  }
}

export default {
  // namespaced: true,
  state,
  mutations,
  actions
}
